import { c as _c } from "react/compiler-runtime";
import './dialpad.scss';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { NavigationProps } from '@sola/schema/lib/schema.ts';
type DialpadProps = {
  item: NavigationProps;
};
export const Dialpad: React.FC<DialpadProps> = t0 => {
  const $ = _c(4);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.items) {
    t1 = item.items?.map(_temp);
    $[0] = item.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="Dialpad gap-comfy-xs">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(i) {
  return <li key={i?.title} className="Dialpad__pad-item flex justify-center"><Link href={i?.link || "#"} target={i?.target} className="Dialpad__link w-full flex gap-snug-xl items-center flex-col label p-snug-xl justify-center label label-neutral label-sm label-potent" title={i?.title}>{i?.icon && <ArkIcon iconName={i?.icon} className="Dialpad__icon" />}{i?.title}</Link></li>;
}